import { ArrowRight, Plus } from "lucide-react";
import { Reveal } from "./Reveal";
import { selectTopic } from "../../data/content";

export const FIRST_VISIT = {
  steps: [
    ["Ankommen", "Du kommst etwas früher, ziehst dich um und lernst deinen Coach kennen."],
    ["Mitmachen", "Wir erklären die Einheit und zeigen dir die Übungen. Gewicht, Tempo und Umfang richten sich nach deinem Trainingsstand."],
    ["Weiterplanen", "Nach dem Kurs besprechen wir kurz, wie es für dich weitergehen könnte."],
  ],
  questions: [
    ["Kann ich allein kommen?", "Ja. Die meisten kommen beim ersten Mal allein. Du wirst gut in die Gruppe integriert – nach ein paar Minuten bist du mittendrin."],
    ["Was passiert, wenn ich eine Übung nicht schaffe?", "Dann machst du eine leichtere Variante. Jede Übung gibt es in mehreren Stufen, und dein Coach zeigt dir, welche heute zu dir passt."],
    ["Was muss ich mitbringen?", "Sportkleidung, saubere Hallenschuhe, ein Handtuch und etwas zu trinken. Umkleiden, Duschen und Schließfächer sind da – ein eigenes Schloss brauchst du nicht."],
    ["Wo parke ich?", "12 kostenlose Parkplätze direkt am Studio. Ab 17 Uhr zusätzlich auf dem AOK-Parkplatz nebenan (Zufahrt über die Heinrichstraße). Mit dem Bus: Haltestelle Südermarkt, wenige Gehminuten."],
    ["Gibt es einen Aufzug?", "Nein, das Studio liegt im Obergeschoss und ist über Treppen erreichbar. Sprich uns an, wenn Treppen für dich ein Thema sind."],
    ["Muss ich danach etwas unterschreiben?", "Nein. Das Probetraining ist kostenlos und unverbindlich. Ob und wie du weitermachst, entscheidest du in Ruhe."],
  ],
};

const Question = ({ q, a, i }) => (
  <details data-testid={`first-visit-q-${i}`} className="group py-4">
    <summary className="tap cursor-pointer list-none flex items-center justify-between gap-4 font-head text-[15px] font-semibold">
      {q}<Plus size={18} className="shrink-0 text-[#BA00C5] transition-transform duration-300 group-open:rotate-45" />
    </summary>
    <p className="mt-2 pr-8 text-sm md:text-[15px] muted leading-relaxed">{a}</p>
  </details>
);

export const FirstVisit = () => (
  <section id="erster-besuch" data-testid="section-first-visit" className="py-12 md:py-16 scroll-mt-24 bg-[#F7F6F3]">
    <div className="max-w-[1320px] mx-auto px-5 md:px-10 grid lg:grid-cols-[0.85fr_1.15fr] gap-10 lg:gap-24">
      <Reveal className="lg:sticky lg:top-28 self-start">
        <p className="eyebrow mb-4" data-testid="first-visit-eyebrow">Dein erster Kurs</p>
        <h2 data-testid="first-visit-heading" className="h-display text-3xl sm:text-4xl lg:text-5xl">Du musst vorher <span className="accent">nichts können.</span></h2>
        <p className="mt-5 text-base md:text-lg muted leading-relaxed max-w-md">So läuft dein Probetraining – und die Antworten auf das, was fast alle vorher wissen möchten.</p>
        <button type="button" data-testid="first-visit-cta" onClick={() => selectTopic("einsteiger")} className="btn-accent mt-8 hidden lg:inline-flex">Kostenloses Probetraining anfragen <ArrowRight size={17} /></button>
      </Reveal>
      <div>
        <ol className="border-t border-[#161616]/15">
          {FIRST_VISIT.steps.map(([t, x], i) => (
            <Reveal as="li" key={t} delay={i * 0.05} data-testid={`first-visit-step-${i}`} className="grid grid-cols-[3.5rem_1fr] md:grid-cols-[5rem_1fr] gap-2 py-6 md:py-7 border-b border-[#161616]/15">
              <span className="h-display text-2xl md:text-4xl text-[#BA00C5] leading-none">0{i + 1}</span>
              <div><p className="font-head text-lg md:text-xl font-bold">{t}</p><p className="mt-1.5 text-[15px] muted leading-relaxed">{x}</p></div>
            </Reveal>
          ))}
        </ol>
        <p className="mt-12 font-head text-xs font-semibold uppercase tracking-[0.16em] muted">Häufige Fragen vorher</p>
        <div data-testid="first-visit-questions" className="mt-2 divide-y divide-[#E6E3DD] border-b border-[#E6E3DD]">
          {FIRST_VISIT.questions.map(([q, a], i) => <Question key={q} q={q} a={a} i={i} />)}
        </div>
      </div>
    </div>
  </section>
);
